import React from "react";

import PropTypes from "prop-types";

import useField from "fields/hooks/useField";

function RbField(props) {
  const {
    Component,
    defaultEmptyValue,
    error: errorProp,
    fieldName,
    helperText: helperTextProp,
    onBlur,
    onChangeValue,
    validate,
    value: valueProp,
    ...other
  } = props;

  const { value, touched, error, setFieldValue, setFieldTouched } = useField({
    path: fieldName,
    validate,
  });

  const handleChangeValue = React.useCallback(
    (fieldValue) => {
      setFieldValue(fieldValue);
      if (onChangeValue) {
        onChangeValue(fieldValue);
      }
    },
    [setFieldValue, onChangeValue]
  );

  const handleBlur = React.useCallback(
    (event) => {
      setFieldTouched(true);
      if (onBlur) {
        onBlur(event);
      }
    },
    [setFieldTouched, onBlur]
  );

  return (
    <Component
      {...other}
      error={errorProp ?? Boolean(touched && error)}
      helperText={helperTextProp ?? (touched ? error : undefined)}
      onBlur={handleBlur}
      onChangeValue={handleChangeValue}
      value={valueProp ?? value ?? defaultEmptyValue}
    />
  );
}

RbField.propTypes = {
  Component: PropTypes.object.isRequired,
  defaultEmptyValue: PropTypes.any,
  error: PropTypes.bool,
  fieldName: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  onBlur: PropTypes.func,
  onChangeValue: PropTypes.func,
  validate: PropTypes.func,
  value: PropTypes.any,
};

RbField.defaultProps = {
  defaultEmptyValue: undefined,
  error: undefined,
  helperText: undefined,
  onBlur: undefined,
  onChangeValue: undefined,
  validate: undefined,
  value: undefined,
};

export default React.memo(RbField);
